import React, { Component } from "react";
import PropTypes from "prop-types";
import { Dimmer } from "semantic-ui-react";

import MiscResultsGroup from "./MiscResultsGroup";

class MiscSearchResults extends Component {
  render() {
    if (this.props.results && Object.keys(this.props.results).length > 0) {
      const albums = this.props.results.albums.items;
      const artists = this.props.results.artists.items;
      const playlists = this.props.results.playlists.items;
      return (
        <div>
          <Dimmer.Dimmable
            dimmed={this.props.isLoading && !this.props.results}
            blurring
          >
            <MiscResultsGroup items={albums} header="Albums" />
            <MiscResultsGroup items={artists} header="Artists" />
            <MiscResultsGroup items={playlists} header="Playlists" />
          </Dimmer.Dimmable>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

MiscSearchResults.propTypes = {
  results: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
MiscSearchResults.defaultProps = {
  results: {},
  isLoading: false,
};

export default MiscSearchResults;
